import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';

import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import IndentedCardHeader from '../../../components/IndentedCardHeader/IndentedCardHeader';
import CallButton from '../../../components/CallButton/CallButton';
import DocumentStyleArea from '../../../components/DocumentStyleArea/DocumentStyleArea';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class ServiceChildCard extends React.Component {
  render() {
    const { classes, title, icon, image, imageAlt, content } = this.props;

    const Icon = icon;

    return (
      <div className={classes.root}>
        <Card className='Card'>
          <IndentedCardHeader
            title={
              <React.Fragment>
                <Typography variant='h3' className={classes.titleText}>
                  {title}
                </Typography>
              </React.Fragment>
            }
            avatar={<Icon />}
            classes={{
              avatar: classes.icon,
            }}
          />
          <CardContent className={classes.cardContent}>
            <div>
              {image ? (
                <img
                  src={image}
                  className={classes.image}
                  alt={imageAlt ? imageAlt : ''}
                />
              ) : (
                <Divider className={classes.divider} />
              )}
              <div className={classes.contentContainer}>
                <DocumentStyleArea
                  className={classes.test}
                  content={
                    <React.Fragment>
                      <div>{content}</div>
                    </React.Fragment>
                  }
                />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }
}

ServiceChildCard.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
};

export default withStyles(styles)(ServiceChildCard);
